import React from 'react';
import { useState,useEffect } from 'react';
import './SignUpPage.css';
import { useNavigate } from 'react-router-dom'; 
import { useGoogleLogin } from "@react-oauth/google";
// import { googleAuth } from "../api";
// import { googleSignup } from "../api";


// Import SVG icons
import GoogleIcon from '../images/google-logo.svg';
import MicrosoftIcon from '../images/microsoft-logo.svg';
import AppleIcon from '../images/apple-logo.svg';
import GoogleLogin from './GoogleLogin';



function SignUpPage() {
  
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLoginClick = () => {
    console.log("Navigating back to login page...");
    navigate("/login"); // Navigate back to the login page
  };

  //if already logged in send to homepage
  useEffect(() => {
    const userInfo = localStorage.getItem("user-info");
    if (userInfo) {
      navigate('/');
    }
  }, [navigate]);
  

  const responseGoogle = async (authResult) =>{
    try {
        if (authResult['code']){
          


          
        }
        console.log(authResult);
    } catch (error) {
        console.log("Error while request : ", error);
    }
  }

  const googleLogin = useGoogleLogin({
      onSuccess: responseGoogle,
      onError: responseGoogle,
      flow: 'auth-code'
  })


  const [email, setEmail] = useState('');
  const [name, setName] = useState('')
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({ email: '', password: '' });
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  
  const validateInputs = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /.{8,}/;
    let valid = true;

    const newErrors = { email: '', password: '' };

    if (!emailRegex.test(email)) {
      newErrors.email = 'Please enter a valid email address.';
      valid = false;
    }

    if (!passwordRegex.test(password)) {
      newErrors.password = 'Password must be at least 8 characters long.';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validateInputs()) {
      console.log('Form submitted:', { name, email, password });

      try {
        const url = process.env.REACT_APP_BACKEND_URL + "/auth/signup";
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, email, password }),
        });
        console.log(response)
        const data = await response.json();
        console.log(data)
        if(data.error){
          
          setError(data.error);
        }
        // console.log(data)
        if (response.ok) {
     
          setMessage("Signup Successful")
          setMessage(data.message);
          //add response data to local storage
          
          if(data.message==='verified user'){
            const {email, name} = data;
            const token = data.token;
                  
            const obj = {token, email, name};
            localStorage.setItem("user-info", JSON.stringify(obj));
  
            setTimeout(() => navigate('/'), 2000);

          }
          
          
        } else {
          setError(data.error || "An error occurred. Please try again.");
        }
      } catch (error) {
        console.error("Error during login:", error);
        setError("Interner Server Error, Please Try After Sometimes, And Report the issue")
        setErrorMessage("An error occurred. Please try again.");
      }
    }
  };





  return (
    <>
        
        <div
  className="head"
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Aligns Back and Next Page buttons to opposite sides
    padding: '10px 20px',
  }}
>
  {/* Back Button */}
  <button
    className="back-button"
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      // fontSize: '1.2rem',
    }}
    onClick={() => navigate('/login')}
  >
    
    &#x227A; Back
  </button>

  {/* Next Page Button */}
  {/* <button
    className="next-button"
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      // fontSize: '1.2rem',
    }}
    onClick={() => navigate('/featuresecond')}
  >
    Next Page &#x227B;
  </button> */}
</div>

    
    <div className="login-container">
    {/* <div className="signup-container"> */}

    <div className='logo-margin-below'>
        <h1 className="logo-login middle-align" onClick={() =>navigate('/')}>
        <img src="/CommentInsight Favicon.png" alt="Logo" className="logo-image" />
          CommentInsight</h1>
      </div>
      {/* <h1 className="logo-login" onClick={() =>navigate('/')}>CommentInsight</h1> */}
      
      <h3 className='WELCOME-BACK'>Create a new account</h3>
      <form className="login-form" onSubmit={handleSubmit}>
      {/* <form className="signup-form"> */}
        <input 
          type="text" 
          id="name" 
          name="name" 
          placeholder="Full Name" 
          value={name}
          onChange={(e)=> setName(e.target.value)}
          required 
        />
          {errors.email && <span className="error-message">{errors.email}</span>}
        <input 
          type="email" 
          id="email" 
          name="email" 
          placeholder="Email address" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required 
        />

          {errors.password && <span className="error-message">{errors.password}</span>}
        <div className="password-container">
          <input 
            type={showPassword ? 'text' : 'password'}
            id="password" 
            name="password" 
            placeholder="Password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required 
          />
          <span
              className="input-icon-addon"
              onClick={handleTogglePassword}
              role="button"
              aria-label="Toggle password visibility"
            >
              {showPassword ? (
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M12 6.5c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM2.71 3.16c-.39.39-.39 1.02 0 1.41l1.97 1.97C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.97-.3 4.31-.82l2.72 2.72c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.13 3.16c-.39-.39-1.03-.39-1.42 0zM12 16.5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5zm2.97-5.33c-.15-1.4-1.25-2.49-2.64-2.64l2.64 2.64z"/></svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
            )}
          </span>

        </div>
        <button className="signup-btn" type="submit">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="34px" fill="#FFFFFF"><path d="M80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18q30 0 58.5 3t55.5 9l-70 70q-11-2-21.5-2H400q-71 0-127.5 17T180-306q-9 5-14.5 14t-5.5 20v32h250l80 80H80Zm542 16L484-282l56-56 82 82 202-202 56 56-258 258ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm10 240Zm-10-320q33 0 56.5-23.5T480-640q0-33-23.5-56.5T400-720q-33 0-56.5 23.5T320-640q0 33 23.5 56.5T400-560Zm0-80Z"/></svg>
          Sign Up</button>
      </form>
        {message && <p style={{ color: 'blue', marginTop: '15px' }}>{message}</p>}
        {error && <p style={{ color: 'red', marginTop: '15px' }}>{error}</p>}

      
      
      {/* <div className="login-link">
        <p>Already have an account? <a href="/login">Login</a></p>
      </div> */}

      <div className="login-link">
        <p>Already have an account? <span onClick={handleLoginClick} className="blue-color-underline">Log In</span></p>
        {/* Add onClick event to navigate without refresh */}
      </div>

      <div className="divider">
        <span>OR</span>
      </div>

      <div className="social-login">
        {/* <button onClick={googleLogin} className="social-btn google">
          <img src={GoogleIcon} alt="Google" className="icon" />
          Continue with Google
        </button> */}

        < GoogleLogin />
        {/* <button className="social-btn microsoft">
          <img src={MicrosoftIcon} alt="Microsoft" className="icon" />
          Continue with Microsoft Account
        </button>
        <button className="social-btn apple">
          <img src={AppleIcon} alt="Apple" className="icon" />
          Continue with Apple
        </button> */}
      </div>
    </div>
    </>
  );
}

export default SignUpPage;
